import React from 'react'
import TemplateContent from 'templates/TemplateContent'
import { WithTemplate } from '@morningtrain/react-app'
import { OperationRepository } from '@morningtrain/react-resources'
import { AuthService } from '@morningtrain/react-auth'
import Toastify from 'services/Toastify'
import * as Errors from '@morningtrain/react-errors'

export default function AdminPage ({
  children,
  withGlobalDepartmentFilter = true,
  withoutAllDepartments = false
}) {
  return (
    <OperationRepository>
      <AuthService reloadPageOnUnauthorized>
        <Toastify>
          <WithTemplate template='Admin'>
            <TemplateContent withGlobalDepartmentFilter={withGlobalDepartmentFilter} withoutAllDepartments={withoutAllDepartments}>
              <Errors.Boundary>
                {children}
              </Errors.Boundary>
            </TemplateContent>
          </WithTemplate>
        </Toastify>
      </AuthService>
    </OperationRepository>
  )
}
